import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { SqlQueryPage } from '@/features/data/warehouses/sql-query-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/**
 * Requête SQL sur un entrepôt — `POST /datawarehouses/{id}/queries` (ADR 0020 §5). `?sql=` préremplit
 * la requête (« Requêter dans l'éditeur SQL » d'une table du catalogue) ; rien ne part sans un clic.
 */
export const Route = createFileRoute('/$tenant/sql/$warehouseId/query')({
  validateSearch: (search: Record<string, unknown>): { sql?: string } => {
    const sql = typeof search['sql'] === 'string' ? search['sql'].slice(0, 10_000) : '';
    return sql.trim() ? { sql } : {};
  },
  component: SqlQueryRoute,
});

function SqlQueryRoute() {
  const { tenant, warehouseId } = Route.useParams();
  const { sql } = Route.useSearch();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="sql"
      crumbs={[
        { label: t('nav.items.sql') },
        { label: warehouseId, mono: true },
        { label: t('data.sql.title') },
      ]}
    >
      <SqlQueryPage tenantId={tenant} warehouseId={warehouseId} {...(sql ? { initialSql: sql } : {})} />
    </ConsoleShell>
  );
}
